import "./TopBar.css";
import useTopBar from "./useTopBar";
import { withTranslation } from "react-i18next";
import Vegas from "../../_common/Vegas/Vegas";
import {
  myAccount,
  logout,
  Agile,
  login,
  shopping_cart,
} from "../../../assets/images";

function TopBar(props) {
  const {
    gotoHome,
    showAccount,
    cartPage,
    loginRedirect,
    navigateToMyAccount,
    handleLogout,
    user_id,
    cartCount,
  } = useTopBar();
  const { t } = props;

  /**
   *
   * @returns render top bar
   */
  const renderTopBar = () => {
    return (
      <>
        <div class="top_address flt">
          {t("Maruthi Veethika Rd, Thenkpete, Udupi Karnataka 576101")}
        </div>
        <div className="agile flt">
          <div className="main_agile_image flt">
            <a href="https://bookings.hotelwhitelotus.in/">
              <img src={Agile} alt="no_image" onClick={gotoHome} />
            </a>
          </div>
          {/* <div> {renderVegasBar()}</div> */}
          <div className="main_location flt">
            <div> {renderVegasBar()}</div>
            {/* <div className="cart_btn_img" onClick={cartPage}>
              <span>
                Booking Cart <b>{cartCount}</b>
              </span>{" "}
              <img src={shopping_cart} alt="no_image" />
            </div> */}

            <div className="main_login ">
              {!user_id ? (
                <div className="user_login">
                  <img src={login} alt="no_image" />
                  <div className="log_in" onClick={loginRedirect}>
                    {t("LOGIN")}
                  </div>
                </div>
              ) : (
                <div className="myaccount">
                  <button onClick={showAccount} type="button">
                    <img src={login} alt="no_image" />
                  </button>
                  <ul>
                    <li onClick={navigateToMyAccount}>
                      <img src={myAccount} alt="no_image" />{" "}
                      <span>{t("My_account")}</span>{" "}
                      <i class="far fa-long-arrow-alt-right"></i>
                    </li>
                    <li onClick={handleLogout}>
                      <img src={logout} alt="no_image" />{" "}
                      <span>{t("Logout")}</span>{" "}
                      <i class="far fa-long-arrow-alt-right"></i>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  };

  const renderVegasBar = () => {
    return <Vegas />;
  };

  return <div className="main_agile flt">{renderTopBar()}</div>;
}
export default withTranslation()(TopBar);
